import apiService from 'apiService';
import React, { useState, useEffect, useRef } from 'react';
import withFormLogic from 'view/hoc/withFormLogic';
import withPostFetch from 'view/hoc/withPostFetch';
// import '../../../../../form.css';
import View from './View';

const FormEdit = ({
  field,
  existingPersyaratan,
  setStep, 
  isShow,
}) => {
  return (
    isShow && (
      <>
        <span
          className='text-primary mb-3 d-inline-block'
          style={ { cursor: 'pointer' } }
          onClick={ () => {
            setStep(1);
          } }>
          <i
            className='ni ni-curved-next mr-2'
            style={ { transform: 'scaleX(-1)' } }
          />
          <span className='d-inline'>Kembali</span>
        </span>
        <View
          data={ existingPersyaratan }
        />
        <div className='d-none'>
          <table>
            <tr>
              <td>Tanggal</td>
              <td>:</td>
              <td>{Date.now()}</td>
            </tr>
            <tr>
              <td>Kode Pendaftaran</td>
              <td>:</td>
              <td>{field.pendaftaran_perusahaan_id}</td>
            </tr>
          </table>
        </div>
      </>
    )
  );
};

const postDepartement = async (params) => {
  try {
    const response = await apiService.post(
      '/department/foodhigiene/create',
      params
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export default withPostFetch((params) => postDepartement(params))(
  withFormLogic({
    pendaftaran_perusahaan_id: '',
    categories_results: [],
    sub_sub_categories_results: [],
  })(FormEdit)
);
